import getCalendarSharingCurrentState from '../selectors/getCalendarSharingCurrentState';
import { mutatorAction } from 'satcheljs';
/**
 * Mutator to update change notification status
 */
export default mutatorAction('updateChangeNotificationStatusInCurrentState', function updateChangeNotificationStatusInCurrentState(folderId, status) {
    var currentState = getCalendarSharingCurrentState();
    currentState[folderId] = status
        ? 1 /* Enabled */
        : 0 /* Disabled */;
});
//# sourceMappingURL=updateChangeNotificationStatusInCurrentState.js.map